export enum InvoiceReferenceType {
    None = 0,
    EngagementPurchase = 1,
}
